"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyGenerateStatusQuery = exports.useLazyDownloadAllQuery = exports.useSendAllTenantsMutation = exports.useGenerateBillingMutation = exports.billingApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.billingApi = (0, react_1.createApi)({
    reducerPath: "billingApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    endpoints: function (builder) { return ({
        generateBilling: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/billing/generate",
                method: "POST",
                body: obj,
            }); },
        }),
        sendAllTenants: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/billing/send-all",
                method: "POST",
                body: obj,
            }); },
        }),
        downloadAll: builder.query({
            query: function (obj) { return ({
                url: "/v1/billing/download-all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    billingPeriod: obj.billingPeriod,
                },
                responseHandler: function (response) { return response.blob(); },
            }); },
        }),
        generateStatus: builder.query({
            query: function (obj) { return ({ url: "/v1/billing/generate-status", method: "GET", params: obj }); },
        }),
    }); },
});
exports.useGenerateBillingMutation = exports.billingApi.useGenerateBillingMutation, exports.useSendAllTenantsMutation = exports.billingApi.useSendAllTenantsMutation, exports.useLazyDownloadAllQuery = exports.billingApi.useLazyDownloadAllQuery, exports.useLazyGenerateStatusQuery = exports.billingApi.useLazyGenerateStatusQuery;
